/* eslint-disable @typescript-eslint/no-explicit-any */
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { EncryptKey } from '../../config/constants';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class SessionStorageService {

  constructor(
    @Inject(PLATFORM_ID) private readonly platformId: object
  ) { }

  public saveData(key: string, value: any) {
    if (isPlatformBrowser(this.platformId))
      sessionStorage.setItem(key, value);
  }

  public getData(key: string) {
    return isPlatformBrowser(this.platformId) ? sessionStorage.getItem(key) : '';
  }

  public saveEncryptData(key: string, value: any) {
    if (isPlatformBrowser(this.platformId))
      sessionStorage.setItem(key, this.encrypt(value));
  }

  public getEncryptData(key: string) {
    const data = isPlatformBrowser(this.platformId) ? sessionStorage.getItem(key) || "" : '';
    return this.decrypt(data);
  }

  public removeData(key: string) {
    if (isPlatformBrowser(this.platformId))
      sessionStorage.removeItem(key);
  }

  public clearData() {
    if (isPlatformBrowser(this.platformId)){
      sessionStorage.clear();
      this.deleteCookie();
    }
  }

  private encrypt(txt: string): string {
    return CryptoJS.AES.encrypt(txt, EncryptKey).toString();
  }

  private decrypt(txtToDecrypt: string) {
    return CryptoJS.AES.decrypt(txtToDecrypt, EncryptKey).toString(CryptoJS.enc.Utf8);
  }

  public setCookie(user: any) {
    // save cookie with user, be selective in real life as to what to save in cookie
    let cookieStr = encodeURIComponent('AOCookie') + '=' + encodeURIComponent(JSON.stringify(user));
  
    // use expiration tp expire the cookie
    const dtExpires = new Date(user.expiresAt); 
  
    cookieStr += ';expires=' + dtExpires.toUTCString();
    cookieStr += ';path=/';
    // some good security measures:
    cookieStr += ';samesite=lax';
    // when in production
    
    // be strong:
    document.cookie = cookieStr;
  }
  public deleteCookie(): void {
    // void accessToken but more importantly expire
    this.setCookie({accessToken: '', expiresAt: 0});
  }

}
